module.exports = __webpack_public_path__ + "static/img/main-title3.dd7302a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/trusteeCouncil/images/main-title3.png
// module id = yfnr
// module chunks = 0